import {
	ClientPropertyTypeEnum,
	type ClientPropertyVehicleDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EditCarForm } from "web_myplann/Portfolio/Pages/CarEdit/EditCarForm";
import { PropertyEditLayout } from "web_myplann/Portfolio/PortfolioShared/PropertyEditLayout";

export const EditCarPage = () => {
	const { t } = useResource();

	return (
		<PropertyEditLayout<ClientPropertyVehicleDetailResponseDTO>
			expectedTypes={[ClientPropertyTypeEnum.AutoMoto]}
			title={t(Resources.Portfolio.EditProperty.title)}
		>
			{({ property, propertyId, detailRoute }) => (
				<EditCarForm
					propertyId={propertyId}
					property={property}
					detailRoute={detailRoute}
				/>
			)}
		</PropertyEditLayout>
	);
};
